import { render, staticRenderFns } from "./regist_pc.vue?vue&type=template&id=5e26249a&scoped=true"
import script from "./regist_pc.vue?vue&type=script&lang=js"
export * from "./regist_pc.vue?vue&type=script&lang=js"
import style0 from "./regist_pc.vue?vue&type=style&index=0&id=5e26249a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e26249a",
  null
  
)

export default component.exports